const ROOT = "galleryViewer";
const GALLERY_SETTINGS = "gallery-settings";
const LAYOUT_SELECTION_DROPDOWN = "GalleryPlugin_LayoutDropdown";
const LAYOUT_DROPDOWN_CUSTOMIZE_LAYOUT = "GalleryPlugin_Layout_CustomizeLayout";
const ADD_MEDIA_FILE_INPUT = "galleryItemsSortableFileInputTop";
const PLUS_FILE_INPUT = "galleryItemsSortableFileInputBottom";
const GALLERY_SETTINGS_TABS = "gallerySettingsTabs";
const GALLERY_SETTINGS_EXPAND_TOGGLE = "galleryExpandToggle";
const GALLERY_SETTINGS_IMAGE_DOWNLOAD_TOGGLE = "imageDownloadToggle";
const GALLERY_SETTINGS_SPOILER_TOGGLE = "gallerySpoilerToggle";
const GALLERY_MEDIA_ITEMS = "galleryItemsSortable";
const GALLERY_MEDIA_ITEMS_DELETE = "galleryItemsSortableDelete";
const GALLERY_MEDIA_ITEMS_SELECT_ALL = "galleryItemsSortableSelectAll";
const GALLERY_MEDIA_ITEMS_DESELECT_ALL = "galleryItemsSortableDeselectAll";
const GALLERY_MEDIA_ITEMS_SETTINGS = "galleryItemsSortableItemSettings";
const GALLERY_IMAGE_SETTINGS_DELETE_IMAGE = "galleryImageSettingsDeleteImage";
const GALLERY_IMAGE_PREVIEW_CAROUSEL = "galleryImagePreview";
export {
  ADD_MEDIA_FILE_INPUT,
  GALLERY_IMAGE_PREVIEW_CAROUSEL,
  GALLERY_IMAGE_SETTINGS_DELETE_IMAGE,
  GALLERY_MEDIA_ITEMS,
  GALLERY_MEDIA_ITEMS_DELETE,
  GALLERY_MEDIA_ITEMS_DESELECT_ALL,
  GALLERY_MEDIA_ITEMS_SELECT_ALL,
  GALLERY_MEDIA_ITEMS_SETTINGS,
  GALLERY_SETTINGS,
  GALLERY_SETTINGS_EXPAND_TOGGLE,
  GALLERY_SETTINGS_IMAGE_DOWNLOAD_TOGGLE,
  GALLERY_SETTINGS_SPOILER_TOGGLE,
  GALLERY_SETTINGS_TABS,
  LAYOUT_DROPDOWN_CUSTOMIZE_LAYOUT,
  LAYOUT_SELECTION_DROPDOWN,
  PLUS_FILE_INPUT,
  ROOT
};
//# sourceMappingURL=dataHooks.js.map
